<template>
  <div class="main">
    <div class="nav">
      <div class="nav-con">
        <div class="nav-cons">
          <div
            v-for="(item, key) in navList"
            :key="key"
            :class="item.class"
            @click="clicknav(item.path, item.index, item.navid)"
          >
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { get } from "@/utils/index";
import { ref, reactive, onMounted } from "vue";
import { ElMessage } from "element-plus";
// router
import { useRouter } from "vue-router";
const router = useRouter();
// vuex
import { useStore } from "vuex";
const store = useStore();
// computed动态获取state值
import { computed } from "vue";
// 导航列表
let navList = reactive([
  { class: "nav-list", path: "/", index: 0, text: "首页", navid: "" },
  {
    class: "nav-list",
    path: "/hdzq/list",
    index: 1,
    text: "活动专区",
    navid: "",
  },
  {
    class: "nav-list",
    path: "/paper/list",
    index: 2,
    text: "教育研究",
    navid: "1",
  },
  {
    class: "nav-list",
    path: "/paper/list",
    index: 3,
    text: "科技探索",
    navid: "2",
  },
  {
    class: "nav-list",
    path: "/paper/list",
    index: 4,
    text: "健康科普",
    navid: "3",
  },
  {
    class: "nav-list",
    path: "/paper/list",
    index: 5,
    text: "思政一体",
    navid: "4",
  },
  { class: "nav-list", path: "", index: 6, text: "美育融合", navid: "5" },
  {
    class: "nav-list",
    path: "/paper/list",
    index: 7,
    text: "心理聚焦",
    navid: "6",
  },
  {
    class: "nav-list",
    path: "/paper/list",
    index: 8,
    text: "学校发展",
    navid: "7",
  },
  {
    class: "nav-list",
    path: "/zjdw/list",
    index: 9,
    text: "专家队伍",
    navid: "",
  },
  { class: "nav-list", path: "", index: 10, text: "课题申报", navid: "" },
  { class: "nav-list", path: "/tgrk", index: 11, text: "投稿入口", navid: "" },
]);

// 获取所有报纸
// const getbqxq = () => {
//   get("/api/NewsPaper/GetAllNewsPaper").then((res) => {
//     // 保存全部报纸属性到vuex
//     store.commit("updatebaozhiall", res.data);
//     res.data.forEach((e) => {
//       if (e.nptitle === "健康人报") {
//         navList[3].navid = e.Id;
//       }
//     });
//   });
// };
// getbqxq();

// 监听navindex索引修改样式
let navindex = ref(-1);
if (router.currentRoute.value.query.idx) {
  // mutaions修改索引
  store.commit("updateNavindex", parseInt(router.currentRoute.value.query.idx));
  navindex.value = parseInt(router.currentRoute.value.query.idx);
} else {
  navindex = computed(() => store.state.navindex);
}
// 导航定位
const updateSy = () => {
  navList.forEach((e, i) => {
    e.class = "nav-list";
    if (i === navindex.value) {
      e.class = "nav-list nav-list-active";
    }
  });
};

//  点击导航
const clicknav = (data, index, navid) => {
  // 健康人报跳转外链
  if(index==4){
    window.open('http://jkrb.ktnw.cn/')
  }

  // mutaions修改索引
  store.commit("updateNavindex", index);
  // 保存
  window.localStorage.setItem("navid", index);
  // 跳转
  if (data == "") {
    ElMessage({
      message: "暂未开放",
      type: "info",
    });
  } else {
    // 重置临时页码
    store.commit("updatepageindextemp",1)
    router.push({
      path: data,
      query: {
        idx: index,
        dflid: navid, //大分类id
        // acn:"chengguo",//tab标签属性
      },
    });
  }
};
onMounted(() => {
  updateSy();
});
</script>

<style scoped>
.nav {
  width: 100%;
  height: 60px;
  background: #296fab;
  color: #fff;
}
.nav-con {
  width: 1200px;
  height: 100%;
  margin: auto;
}
.nav-cons {
  width: auto;
  height: 100%;
  float: left;
}
.nav-cons:after {
  content: "";
  display: table;
  clear: both;
}
.nav-list {
  float: left;
  width: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  padding: 0 15px;
  cursor: pointer;
}
.nav-list-active {
  background: #59bdd1;
  cursor: default;
}
.nav-list:hover {
  background: #59bdd1;
}
</style>
